<template>
  <div class="banner">
    <div class="banner-wrapper">
      <!-- 左侧标题 -->
      <div class="content-ai">
        <img class="content-ai-logo" :src="isMobile ? data.mobileAiLogo : data.aiLogo" alt="" />
        <p class="content-ai-titleCh">{{data.titleCh}}</p>
        <p class="content-ai-titleEn">{{data.titleEn}}</p>
      </div>

      <!-- 右侧二维码 && 链接 -->
      <div class="content-wrapper">
        <div class="content-qr">
          <div class="content-qr-wrapper">
            <img class="content-qr-img" :src="isMobile ? data.mobileQrLeft : data.qrLeft" alt="">
            <p class="content-caption">{{data.caption}}</p>
          </div>
          <div class="content-qr-wrapper">
            <img class="content-qr-img" :src="isMobile ? data.mobileQrRight : data.qrRight" alt="">
            <p class="content-caption">{{data.joinGroup}}</p>
          </div>
        </div>
        <!-- <div> -->
          <!-- <p class="content-caption">{{data.caption}}</p> -->

        <!-- </div> -->
        <div class="content-link">
          <div class="content-list" v-for="(data, index) in data.platform" :key="index">
            <a class="content-list-link" :href="data.link" target="_blank">{{isMobile ? data.mobileTitle : data.title}}</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueTypes from 'vue-types'
import { mapState } from 'vuex'

export default {
  props: {
    data: VueTypes.object.def({})
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapState(['isMobile'])
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
.banner {
  width: 100%; height: 574px;
  margin-top: 67px;
  background: url('~@/assets/transSave/resource/image/e2/71/e29yy52b9557427a9f2496150b846671.png') center / cover no-repeat;

  @include mobile {
    width: 100%; height: 390px;
    background: url('~@/assets/transSave/resource/image/10/5d/10b6a2a0e8736af319a191c35c2fe85d.png') center / cover no-repeat;
  }
}

.banner-wrapper {
  display: flex;
  width: 1200px;
  margin: 0 auto;

  @include mobile {
    flex-wrap: wrap; justify-content: center;
    width: auto;
  }
}

.content-ai {
  display: flex; flex-direction: column; align-items: center;
  margin: 160px 88px 0 0;

  @include mobile {
    display: auto;
    margin: 14px 0 0 0;
  }
}

.content-ai-logo {
  width: 120px; height: 120px;

  @include mobile {
    width: 60px; height: 60px;
  }
}

.content-ai-titleCh {
  color: #000000;
  font-size: 46px; font-family: Alibaba-PuHuiTi-Heavy;
  line-height: 63px;

  @include mobile {
    font-size: 22px;
    line-height: 30px;
  }
}

.content-ai-titleEn {
  color: #303030;
  font-size: 31px; font-family: Alibaba-PuHuiTi-Heavy;
  line-height: 43px;
  letter-spacing: 1px;

  @include mobile {
    font-size: 16px;
    line-height: 22px;
  }
}

.content-wrapper {
  box-sizing: border-box;
  display: flex; flex-direction: column; align-items: center;
  width: 760px; height: 414px;
  margin-top: 80px;
  padding: 60px 48px;
  background: rgba(255,255,255,0.3700);
  backdrop-filter: blur(10px);

  @include mobile {
    margin-top: 30px;
    padding: 0;
    background: none;
  }
}

.content-qr {
  display: flex;

  @include mobile {
    order: 1;
    margin-top: 36px;
  }
}

.content-qr-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;

  &:first-child {
    margin-right: 80px;

    @include mobile {
      margin-right: 34px;
    }
  }
}

.content-qr-img {
  width: 150px; height: 150px;

  @include mobile {
    width: 90px; height: 90px;
  }
}

.content-caption {
  margin: 18px 0 44px;
  color: #000000;
  font-size: 16px; font-weight: 400;
  line-height: 22px;
  opacity: 0.5;

  @include mobile {
    order: 2;
    font-size: 11px;
    line-height: 16px;
  }
}

.content-link {
  display: flex;

  @include mobile {
    order: 0;
  }
}

.content-list {
  &:last-child .content-list-link {
    margin-right: 0;
  }
}

.content-list-link {
  box-sizing: border-box;
  height: 60px;
  padding: 15px 35px;
  margin-right: 30px;
  color: #000000;
  background: #FFFFFF;
  font-size: 20px; font-weight: 500;
  line-height: 30px;

  &:hover {
    background-color: rgba(255,255,255,0.5);
  }

  @include mobile {
    height: 38px;
    padding: 10px 18px;
    margin-right: 16px;
    font-size: 13px; font-weight: 500;
    line-height: 18px;
  }
}
</style>
